/* eslint-disable no-restricted-syntax */
/* eslint-disable keyword-spacing */
/* eslint-disable camelcase */
/* eslint-disable space-before-blocks */
/* eslint-disable no-console */
/* eslint-disable padded-blocks */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable indent */
// /* JS to add click event listeners to the main menu `menu--main.html.twig` */
import getKeyboardFocusableElements from '../accessibility/getKeyboardFocusableElements';

function isHeaderOpen(header) {
  return header.classList.contains('dropdown-expanded');
}

function closeMenu() {
  document.querySelector('body').classList.remove('no-scroll');

  document.getElementById('header').classList.remove('dropdown-expanded');

  const overlay = document.getElementById('menu-overlay');
  if (overlay) {
    overlay.classList.remove('active');
  }

  const actives = document.querySelectorAll('.mega-menu .active');
  for (const active of actives) {
    active.classList.remove('active');
  }

  const expandeds = document.querySelectorAll('.mega-menu .expanded');
  for (const expanded of expandeds) {
    expanded.classList.remove('expanded');
  }
}

const toggleMobileMainNav = () => {
  if (
    document.getElementById('header')
    && document.getElementById('main-nav-burger')
  ) {
    const header = document.getElementById('header');
    const burger = document.getElementById('main-nav-burger');

    header.classList.toggle('dropdown-expanded');
    burger.classList.toggle('main-nav-burger--open');
    burger.classList.toggle('main-nav-burger--closed');

    const brand = document.querySelector('.header__brand');
    if (brand) {
      brand.classList.toggle('header__brand--open');
      brand.classList.toggle('header__brand--closed');
    }

    const navigation = document.querySelector('.header__navigation');
    if (navigation) {
      navigation.classList.toggle('header__navigation--open');
      navigation.classList.toggle('header__navigation--closed');
    }

    const language = document.querySelector('.header__language');
    if (language) {
      language.classList.toggle('header__language--open');
      language.classList.toggle('header__language--closed');
    }

    const button = document.querySelector('.header__button');
    if (button) {
      button.classList.toggle('header__button--open');
      button.classList.toggle('header__button--closed');
    }
  }
};

const addMainNavToggleHandlers = () => {
  if (document.getElementById('main-nav-burger')) {
    const el = document.getElementById('main-nav-burger');
    el.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMobileMainNav();
    });

    /** Add click for keyboard enter to improve keyboard accessibility */
    el.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        el.click();
      }
    });
  }
  const dropDownlinks = document.querySelectorAll('.button-menu-dropdown');
  dropDownlinks.forEach((link) => {
    link.addEventListener('click', () => {
      const item = document.querySelector('.js-toggle-focus.js-expanded');
      item.classList.toggle('focus');
    });

    link.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const item = document.querySelector('.js-toggle-focus.js-expanded');
        item.classList.toggle('focus');
      }
    });
  });

  jQuery('#mega-menu').on('focusout', () => {
    setTimeout(() => {
      if (document.querySelectorAll('#mega-menu :focus').length === 0) {
        toggleMobileMainNav();
        closeMenu();
      }
    }, 200);
  });
};

export function initMenuMain() {
  addMainNavToggleHandlers();

  const header = document.getElementById('header');

  /** For accessibilty, we trap tab focus within the menu modal */
  const focusables = getKeyboardFocusableElements(header);

  //  The first focusable element should be #main-nav-burger, so get that index
  //  If that doesn't exist, default to 0
  let firstFocusableIndex = 0;

  focusables.forEach((focusable, i) => {
    if (focusable.getAttribute('id') === 'main-nav-burger') {
      firstFocusableIndex = i;
    }
  });

  const firstEl = focusables[firstFocusableIndex];
  const lastEl = focusables[focusables.length - 1];

  window.addEventListener('keydown', (e) => {
    if (!isHeaderOpen(header)) return;
    if (e.key === 'Tab') {
      // Leaving the first element with Tab : focus the last one
      if (document.activeElement === firstEl && e.shiftKey) {
        e.preventDefault();
        lastEl.focus();
      }
      // Leaving the last element with Tab : focus the first one
      if (document.activeElement === lastEl && !e.shiftKey) {
        e.preventDefault();
        firstEl.focus();
      }
    }
    if (e.key === 'Escape') {
      toggleMobileMainNav();
    }
  });

  //   document.getElementById('mega-menu').addEventListener("focusout", closeMenu);

  //    Get all elements that display a section when clicked
  //    (we store the ID of the target container in an attribute
  //    on the clickable element, so use that to target
  const menu_toggle_links = document.querySelectorAll('[content-container-id]');

  //    Attach a click event to all those links
  menu_toggle_links.forEach((menu_toggle_link) => {
    menu_toggle_link.addEventListener('click', (e) => {
      let closing = false;

      if (menu_toggle_link.classList.contains('active')) {
        closing = true;
      }

      e.preventDefault();

      //  The element that will be displayed is determined by an attribute on the link
      //  The attribute should be the ID of the target element
      const display_area_element = document.getElementById(
        menu_toggle_link.getAttribute('content-container-id'),
      );

      //  Add class to the header so it can be fixed while the menu is open
      if (menu_toggle_link.classList.contains('menu__link')) {
        // document.getElementsByClassName('menu__link active').classList.remove('active');
        document.getElementById('header').classList.add('dropdown-expanded');
      }

      //  Remove the .expanded class from elements of the same type as the target
      //  This is done by matching classes
      const currently_expanded = document.getElementsByClassName(
        `${display_area_element.className} expanded`,
      );
      for (const ce of currently_expanded) {
        ce.classList.remove('expanded');

        //  Check if we are clicking on a currently expanded element
        if (
          menu_toggle_link.getAttribute('content-container-id')
            === ce.getAttribute('id')
          && document
            .getElementById('header')
            .classList.contains('dropdown-expanded')
        ) {
          //  Check if we are closing the whole menu
          //  If the closest <ul> is the container, then we are closing the menu
          if (menu_toggle_link.closest('ul').classList.contains('mega-menu')) {
            closeMenu();
          } else {
            menu_toggle_link.classList.remove('active');
          }
          return;
        }
      }

      //  Add the expanded class to display the target element
      if (!closing) {
        display_area_element.classList.add('expanded');
        const overlay = document.getElementById('menu-overlay');
        if (overlay) {
          overlay.classList.add('active');

          overlay.addEventListener('click', closeMenu);
        }
        /** Put no-scroll on the body */
        document.querySelector('body').classList.add('no-scroll');
      }

      //  Remove the .active class from elements of the same type as the target
      //  This is done by matching classes
      const currently_active = document.getElementsByClassName(
        `${menu_toggle_link.className} active`,
      );
      for (const ca of currently_active) {
        ca.classList.remove('active');
      }

      //  Add the active class to the menu item
      if (!closing) {
        menu_toggle_link.classList.add('active');
      }
    });
  });
}

export default 'initMenuMain';
